import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { ResourcePill } from '../../components/avatar-pill/resource-pill';
import { WeekdayColumnHeader } from '../../components/weekday-column-header';
import { useCalendarGridStore } from '../../store/calendar-grid.store';
import { CalendarColumn, CalendarColumnHeaderType } from '../../types';

interface Props {
  columnId: string;
  headerType: CalendarColumnHeaderType;
}

export const ColumnHeader = ({ columnId, headerType }: Props) => {
  const columnInfo = useCalendarGridStore((s) => s.columnsById[columnId]);

  if (!columnInfo) return null;

  if (headerType === 'weekday') {
    const { dayOfMonth, name, slotsCount } = columnInfo as CalendarColumn<'weekday'>;
    return <WeekdayColumnHeader dayOfMonth={dayOfMonth} weekday={name} slotsCount={slotsCount} />;
  }

  if (headerType === 'provider') {
    const { name, providerImage } = columnInfo as CalendarColumn<'provider'>;
    return <ResourcePill name={name} avatarSrc={providerImage} />;
  }

  if (headerType === 'operatory') {
    const { name, operatoryIcon } = columnInfo as CalendarColumn<'operatory'>;
    return <ResourcePill name={name} iconName={operatoryIcon} />;
  }

  return <Text css={textStyle}>{columnInfo.name}</Text>;
};

const textStyle = css({
  borderInlineWidth: '0 1px',
  borderInlineStyle: 'solid',
  borderInlineColor: theme.colors.neutral10,
  textAlign: 'center',
});
